<template>
  <div :class="{'is-wide': isWide}" class="card quickstart">
    <div class="card-content">
      <div class="deck-banner-button">
        <div class="circle-backdrop">
          <b-icon v-if="!imgSrc" :icon="icon" pack="fas" size="is-large" />
          <img v-else :src="imgSrc" :alt="label" class="icon is-large is-ppt">
        </div>
        <h3 v-if="!isWide">{{ label }}</h3>
      </div>
    </div>
    <h3 v-if="isWide">{{ label }}</h3>
  </div>
</template>

<script>
export default {
  name: 'DeckBannerButton',
  props: {
    imgSrc: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    }
  },
  computed: {
    isWide () {
      return this.size === 'wide'
    }
  }
}
</script>

<style scoped lang="scss">
@import "/assets/css/components";

.card.quickstart {
  transition: transform 0.2s ease-in-out;
  cursor: pointer;

  .circle-backdrop {
      background: #ffeaf1;
      border-radius: 50%;
      height: 4em;
      width: 4em;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 1em;
    }
  .icon {
    width: 4em;
    height: 4em;
  }

  &.primary {
    color: $primary;

    .circle-backdrop {
      background: #ffeaf1;
    }
  }

  &.secondary {
    color: $secondary;

    .circle-backdrop {
      background: #def9fd;
    }

    .card-content {
      background: #f8f9fc;
    }

    .icon {
      transform: scale(1.2, 1.2);
    }
  }

  &.gray {
    .circle-backdrop {
      background: #d9dedf;
    }

    .card-content {
      background: #f5f5f7;
    }

    .icon {
      transform: scale(1.2, 1.2);
    }
  }

  &.powerpoint {
    color: #b93316;
  }

  .card-content {
    background: #fff5f8;
    display: flex;
    justify-content: center;

    &.powerpoint {
      background: #e1f4f9;
    }
  }

  &:hover {
    transform: scale(1.02, 1.02);
  }

  &.is-wide {
    transition: transform .13s ease;
    padding: 10px 10px;
    border: none;
    border-radius: 6px;
    box-shadow: none;
    width: 100%;

    .card-content {
      border-radius: 6px;
      padding: 25px 20px;
      width: 100%;
      height: calc(6.5rem);

      .circle-backdrop {
        margin-bottom: 0;
      }
    }

    h3 {
      font-size: .75rem;
      font-weight: bold;
      text-align: center;
      margin-top: 5px;
    }

    .deck-banner-button{
      font-size: 1rem;

      .icon, .circle-backdrop, .icon.is-large {
        width: 2.8em;
        height: 2.8em;
      }

      :deep(.icon .fa-2x) {
        font-size: 1.5em;
      }
    }
  }

}

.deck-banner-button {
  text-align: center;
  cursor: pointer;
  color: currentColor;

  h3 {
    font-size: $font-size-3;
    margin-top: $margin-2;
    font-weight: bold;
  }
}
</style>
